var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-list",staticStyle:{"overflow":"hidden"},attrs:{"id":"dom"}},_vm._l((_vm.shopItem),function(item,i){return _c('div',{key:i,staticClass:"title-list-item"},[_c('img',{staticClass:"img",attrs:{"src":"static/img/Visits.png","width":"18px","height":"18px"}}),_c('span',{staticClass:"title"},[_vm._v(_vm._s(item))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }